import React from "react";

import { Order } from "../../../../models";
import { InvoicesCard } from "../InvoicesCard/InvoicesCard";
import { OrderProfitCard } from "../OrderProfitCard/OrderProfitCard";

import "./OrderDetailTabs.scss";

type TabId = "invoices" | "profit";

interface Props {
  order: Order;
}

// Tabbed section below the order details: Invoices (existing) + Profit (svc-037).
// Profit content mounts only when its tab is active, so its fetch is lazy.
export function OrderDetailTabs({ order }: Props) {
  const [tab, setTab] = React.useState<TabId>("invoices");

  return (
    <div className="order-detail-tabs-component">
      <div className="tab-bar" role="tablist">
        <button
          role="tab"
          aria-selected={tab === "invoices"}
          className={`tab ${tab === "invoices" ? "active" : ""}`}
          onClick={() => setTab("invoices")}
        >
          Invoices
        </button>
        <button
          role="tab"
          aria-selected={tab === "profit"}
          className={`tab ${tab === "profit" ? "active" : ""}`}
          onClick={() => setTab("profit")}
        >
          Profit
        </button>
      </div>

      <div className="tab-content">
        {tab === "invoices" && <InvoicesCard order={order} />}
        {tab === "profit" && <OrderProfitCard orderId={order.id} />}
      </div>
    </div>
  );
}
